import styled from 'styled-components';

export const StyledErrorState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #767676;
  margin: 64px;
`;

export const ErrorStateIcon = styled.i`
  font-size: 80px;
  color: #bbb;
`;

export const ErrorStateContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 16px 0 40px;
`;

export const ErrorStateTitle = styled.div`
  font-weight: 600;
  font-size: 32px;
  margin-bottom: 8px;
`;

export const ErrorStateMessage = styled.div`
  font-size: 18px;
`;

export const ErrorStateActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
